import React from "react";
import { BsCaretLeft, BsCaretRight } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";
import ReactPlayer from "react-player";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";

type VideoImageZoomProps = {
  selectedVideos: string[];
  handleClose: () => void;
  playing: boolean;
  playerRef: React.MutableRefObject<null>;
  allMediaUrls: string[];
  currentIndex: number;
  handlePrev: () => void;
  handleNext: () => void;
  play: () => void;
  pause: () => void;
  totalMedias: number;
};
const VideoImageZoom: React.FC<VideoImageZoomProps> = ({
  selectedVideos,
  handleClose,
  playing,
  playerRef,
  allMediaUrls,
  currentIndex,
  handleNext,
  handlePrev,
  play,
  pause,
  totalMedias,
}) => {
  return (
    <div className="picModal bg-black fixed inset-0 py-10 z-30 justify-center overflow-y-hidden items-center flex">
      <div className="p-4 flex items-center justify-center overflow-hidden">
        {(() => {
          const media = allMediaUrls[currentIndex];
          const ipfsHashes = media.match(/\bQm\w{44}\b/g);
          let videoHash, thumbnailHash;

          if (ipfsHashes) {
            [videoHash, thumbnailHash] = ipfsHashes;
          }

          if (selectedVideos.includes(allMediaUrls[currentIndex])) {
            return (
              <div className="flex w-[50%] h-[35%] py-5">
                <ReactPlayer
                  ref={playerRef}
                  url={ipfsGatewayImage(videoHash!)}
                  width="100%"
                  height="100%"
                  controls={true}
                  playing={playing}
                  onPlay={play}
                  onPause={pause}
                  volume={1}
                  muted={true}
                  light={<img src={ipfsGatewayImage(thumbnailHash!)} alt="" />}
                />
              </div>
            );
          } else {
            return (
              <div className="flex items-center justify-center">
                <img
                  id="imga"
                  src={ipfsGatewayImage(allMediaUrls[currentIndex])}
                  alt=""
                  loading="lazy"
                  className="w-full object-cover object-center"
                />
              </div>
            );
          }
        })()}
      </div>

      <div className="flex gap-3 fixed top-1 left-1 items-center justify-center">
        <button className="cursor-pointer h-10 w-10 items-center justify-center flex rounded-full">
          <IoMdClose
            size={33}
            className="cursor-pointer text-white"
            onClick={handleClose}
          />
        </button>
        <img src="/logo.png" alt="" className="w-10 h-10" />
      </div>

      {allMediaUrls.length > 1 && (
        <>
          <button
            onClick={handlePrev}
            disabled={currentIndex === 0}
            className="fixed top-[50%] cursor-pointer left-1 h-10 w-10 items-center justify-center bg-white flex rounded-full disabled:bg-CoolGrey"
          >
            <BsCaretLeft size={35} className="cursor-pointer" />
          </button>
          <button
            onClick={handleNext}
            disabled={currentIndex === totalMedias - 1}
            className="fixed top-[50%]  cursor-pointer right-1 h-10 w-10 items-center justify-center bg-white flex rounded-full disabled:bg-CoolGrey "
          >
            <BsCaretRight size={35} className="cursor-pointer" />
          </button>
        </>
      )}
    </div>
  );
};

export default VideoImageZoom;
